module.exports = __webpack_public_path__ + "img/what-we-do-icon-3.3c1fe7f4.svg";